const browserUtils = {
  /* 是否是ie浏览器 */
  isIE: function () {
    let doc = document.documentElement
    if (doc) {
      let style = doc.style
      return '-ms-scroll-limit' in style && '-ms-ime-align' in style
    }
  },
  /* 是否是移动端 */
  isMobile: function () {
    return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent)
  }
}

export default browserUtils



// WEBPACK FOOTER //
// ./src/util/browserUtils.js